import React, { useMemo } from 'react';
import { TypedMemo } from '../../common/types';
import { SMLRouteNames } from '../../../routing/sml/SMLRoutes';
import { SMLSectionTabs } from '../components/SMLSectionTabs/SMLSectionTabs';
import { insightsTabs } from './insightsTabs';
import { insightsMessages } from './insightsMessages';

interface InsightsTabRowProps {
  /** The tab on screen. */
  screen: SMLRouteNames.streaming | SMLRouteNames.social | SMLRouteNames.fans;
}

/** The Streaming · Social · Fans row under the Insights title (design navigation-v2 b). */
const InsightsTabRowComponent: React.FC<InsightsTabRowProps> = ({ screen }) => {
  const tabs = useMemo(() => insightsTabs(screen), [screen]);
  return <SMLSectionTabs tabs={tabs} ariaLabel={insightsMessages.title} />;
};

export const InsightsTabRow = TypedMemo(InsightsTabRowComponent);
